import * as React from "react";

import Memory from "./Memory";
import Output from "./Output";
import Source from "./Source";

export default () => (
  <div>
    <Output />
    <Source />
    <Memory />
  </div>
);



// WEBPACK FOOTER //
// ./components/Board/Computer/index.tsx